import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Moment } from "moment";

interface FormInterface {
  from?: Moment;
  to?: Moment;
}

interface InitialState {
  data: FormInterface;
}

const initialState: InitialState = {
  data: {
    from: undefined,
    to: undefined,
  },
};

const newsFilterFormSlice = createSlice({
  name: "newsFilterForm",
  initialState,
  reducers: {
    newsFilterFormUpdate: (state, action: PayloadAction<FormInterface>) => {
      state.data = { ...state.data, ...action.payload };
    },
    newsFilterFormReset: () => {
      return { ...initialState };
    },
  },
});

export const { newsFilterFormUpdate, newsFilterFormReset } =
  newsFilterFormSlice.actions;

export default newsFilterFormSlice.reducer;
